import {keys} from 'ts-transformer-keys';
import {DataStructure} from '~/shared/src/utilities/dataStructure';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


export type Query = {
        id : number;
        key : string;
        name : string;

        schema : Schema;
        parameters? : string[];
    }
    & (
    {
        type : 'Cypher' | 'SQL';

        query : string;
        dataStructure? : never;
    }
    | {
    type : 'DataStructure';

    query? : never;
    dataStructure : DataStructure;
}
    );
export const queryProps = keys<Query>();
export const requiredQueryProps = keys<RequiredOf<Query>>();
